import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import EcrionFrame from '../../frame/FrameBase';
import { Dialog } from '@material-ui/core';
import crossDocumentProtocol from '../../frame/FrameBase/crossDocumentProtocol';
import Extensions from '../../apps/Extensions';
/**
 * @extends {React.Component<import('./types').EngagementEditorProps>}
 */

var EngagementEditor =
/*#__PURE__*/
function (_React$Component) {
  _inherits(EngagementEditor, _React$Component);

  function EngagementEditor() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, EngagementEditor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(EngagementEditor)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleCloseMessage = function () {
      _this.props.onClose();
    };

    return _this;
  }

  _createClass(EngagementEditor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      crossDocumentProtocol.on('close-editor', this.handleCloseMessage);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      crossDocumentProtocol.off('close-editor', this.handleCloseMessage);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          journeyId = _this$props.journeyId,
          projectTags = _this$props.projectTags,
          onClose = _this$props.onClose;
      return React.createElement(Dialog, {
        open: true,
        fullScreen: true,
        onClose: onClose
      }, journeyId && React.createElement(Extensions, {
        extensionFor: "JourneyEditor",
        id: journeyId
      }), React.createElement(EcrionFrame, {
        useEcrionServer: true,
        url: "embed/Engage?projectTags=".concat(projectTags, "&returnUrl=message-close-editor#engage/JourneyEditor/") + journeyId,
        height: "100vh"
      }));
    }
  }]);

  return EngagementEditor;
}(React.Component);

export default EngagementEditor;